import { QueryClient, useQuery, UseQueryResult } from '@tanstack/react-query';
import { AxiosError } from 'axios';

import { axiosInstance } from '../../axios';
import { OrganizationGroup } from './types';

export const ORG_GROUPS_QUERY_KEY = ['organization-groups'] as const;

interface Envelope<T> {
  success: boolean;
  message: string;
  data: T;
}

export const useGetOrganizationGroups = (): UseQueryResult<OrganizationGroup[], AxiosError> => useQuery<OrganizationGroup[], AxiosError>({
  queryKey: ORG_GROUPS_QUERY_KEY,
  queryFn: async () => {
    const res = await axiosInstance.get<Envelope<OrganizationGroup[]>>('/v3-getOrganizationGroups');
    const data = res.data?.data;
    if (!Array.isArray(data)) {
      throw new Error('Nieoczekiwany kształt odpowiedzi /v3-getOrganizationGroups');
    }
    return data;
  },
  staleTime: 1000 * 60 * 5,
  refetchOnWindowFocus: false,
  retry: (failureCount, error) => {
    const status = error?.response?.status;
    if (status && status >= 400 && status < 500) return false;
    return failureCount < 3;
  },
});

export const invalidateOrganizationGroups = (queryClient: QueryClient): void => {
  queryClient.invalidateQueries({ queryKey: ORG_GROUPS_QUERY_KEY });
  queryClient.invalidateQueries({ queryKey: ['organizations'] });
};
